import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-invoices';

const getCustomerInvoiceListByStatusCode = async ({
  customerId,
  statusCode,
  page,
  limit,
  search,
  orderBy
}) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?headquarterCustomerId=${customerId}&page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}&statusCode=${statusCode}`;

  const json = await request({ method, url });
  return json;
};

export default getCustomerInvoiceListByStatusCode;
